/**
 * Loading Spinner Component
 * Beautiful animated loader for async operations
 */

import React from "react";
import "./Loaders.css";

export const LoadingSpinner = ({ message = "Loading..." }) => (
  <div className="loading-container">
    <div className="spinner"></div>
    <p className="loading-message">{message}</p>
  </div>
);

export const SkeletonCard = ({ lines = 3 }) => (
  <div className="skeleton-card">
    {Array.from({ length: lines }).map((_, i) => (
      <div key={i} className="skeleton-line"></div>
    ))}
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="skeleton-table">
    <div className="skeleton-header">
      {Array.from({ length: cols }).map((_, i) => (
        <div key={i} className="skeleton-cell"></div>
      ))}
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="skeleton-row">
        {Array.from({ length: cols }).map((_, j) => (
          <div key={j} className="skeleton-cell"></div>
        ))}
      </div>
    ))}
  </div>
);
